import { mapState } from 'vuex';
import {
  AddressingType,
  ApartmentDTO,
  BuildingDTO,
  EntrancePlantDetailDTO,
} from '@/../client-generator/generated-clients/plants';
import { Options, Vue } from 'vue-class-component';
import { loadRisersFloorsApartments } from '@/core/utils/EntrancePlant/entrance-plant.utils';

@Options({
  name: 'ApartmentSelector',
  props: {
    selectedBuilding: {
      type: BuildingDTO,
      required: false,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  emits: ['apartment-selected'],
})
export default class ApartmentSelector extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  selectedBuilding!: BuildingDTO;
  selectedApartment: ApartmentDTO | null = null;

  AddressingType = AddressingType;

  mounted() {}

  get buildingStructure() {
    if (this.selectedBuilding?.risers === undefined) return [];
    return loadRisersFloorsApartments(this.selectedBuilding);
  }

  apartmentSelected() {
    this.$emit('apartment-selected', this.selectedApartment);
  }

  isLast(index: number, array?: ApartmentDTO[]) {
    if (array === undefined) return false;
    return index === array.length - 1;
  }

  maxBadgesReached(apartment: ApartmentDTO) {
    if (apartment.badgeList === undefined) return false;
    return apartment.badgeList.length >= 10;
  }
}
